import React, { ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import { FontelloIconType } from '../../../themes/FontelloIconType'
import { IconSizeTypes } from './IconInterfaces'

export type TeaserIconProps = {
    size?: IconSizeTypes | IconSizeTypes[]
    icon: FontelloIconType
}

type SizeProps = {
    width: number
    fontSize: number
}

type SizeResponsiveProps = {
    width: number[]
    fontSize: number[]
}

const mapSize = (size: IconSizeTypes): SizeProps => {
    if (size === 'L') return { width: 88, fontSize: 34 }
    if (size === 'M') return { width: 68, fontSize: 26 }
    if (size === 'S') return { width: 48, fontSize: 18 }
    return { width: 30, fontSize: 14 }
}

const getSize = (size: IconSizeTypes | IconSizeTypes[]): SizeProps | SizeResponsiveProps => {
    if (Array.isArray(size)) {
        const responsiveSize: SizeResponsiveProps = { width: [], fontSize: [] }
        size.forEach(sizeValue => {
            const { width, fontSize } = mapSize(sizeValue)
            responsiveSize.width = [...responsiveSize.width, width]
            responsiveSize.fontSize = [...responsiveSize.fontSize, fontSize]
        })
        return responsiveSize
    }

    return mapSize(size)
}

const mapMarginLeft = (size: IconSizeTypes): string => {
    if (size === 'L') return '7px'
    if (size === 'M') return '5px'
    return '3px'
}

const getMarginLeft = (
    icon: FontelloIconType,
    size: IconSizeTypes | IconSizeTypes[]
): string | string[] => {
    if (icon === 'play-active') {
        return Array.isArray(size)
            ? size.map(sizeValue => mapMarginLeft(sizeValue))
            : mapMarginLeft(size)
    } else if (icon === 'podcast-active') {
        return '1px'
    }
    return '0'
}

const TeaserIcon = ({ size = 'S', icon }: TeaserIconProps): ReactElement => {
    const { width, fontSize } = getSize(size)
    return (
        <Grid
            noExpand
            margin={3}
            height={width}
            width={width}
            borderRadius={
                Array.isArray(width) ? width.map(widthValue => widthValue / 2) : width / 2
            }
            border={1}
            borderColor="WHITE"
            backgroundColor="onyx-opacity-50"
            center
        >
            <Grid minHeight={width} width={width} center>
                <FontelloIcon
                    name={icon}
                    fontSize={fontSize}
                    color="WHITE"
                    marginLeft={getMarginLeft(icon, size)}
                    marginRight={icon === 'gallery-active' ? '1px' : 0}
                    textAlign="center"
                />
            </Grid>
        </Grid>
    )
}

export default TeaserIcon
